import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";
import { Navigate } from "react-router-dom";
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function LoginPage() {
  const { user, loading } = useAuth();

  useEffect(() => {
    // preload
  }, []);

  if (!loading && user) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0B1020] px-6" data-testid="login-page">
      <div className="absolute inset-0 grid-pattern opacity-60" />
      <div className="absolute inset-0 radial-glow" />
      <div className="relative w-full max-w-md rounded-3xl border border-white/10 bg-[#131B2F] p-10">
        <div className="flex justify-center">
          <Logo size={44} />
        </div>
        <h1 className="mt-8 text-center text-3xl font-bold tracking-tight text-white">
          Admin <span className="gradient-text">Dashboard</span>
        </h1>
        <p className="mt-3 text-center text-sm text-white/60">
          Sign in with Google to manage your website content.
        </p>
        <button
          onClick={handleLogin}
          data-testid="login-google-btn"
          className="group relative mt-10 flex w-full items-center justify-center gap-3 rounded-full px-6 py-3.5 text-sm font-semibold text-white"
        >
          <span className="absolute inset-0 rounded-full gradient-bg" />
          <span className="relative">Continue with Google</span>
        </button>
        <p className="mt-6 text-center text-xs text-white/40">
          Only authorized admins can access the dashboard.
        </p>
      </div>
    </div>
  );
}
